<template>
  <v-layout row wrap class="pp-full-flex grey lighten-4">
  <v-container>
    <v-container class="center" xs12>
      <img width="250" height="250" src="../../../assets/me.png" class="profile-pic"/>
    </v-container>
    <v-container align-center class="center" xs12>
      <div  v-for="(soc,i) in social" :key="i">
        <v-btn icon flat :href="soc.href" target="_blank">
          <div class="center" :style="{fontSize:'0.7em', color: '#616161'}">
            <v-icon>{{soc.icon}} fa-3x</v-icon>
          </div>
        </v-btn>
      </div>
    </v-container>
  </v-container>
  </v-layout>
</template>

<script>
  import json from '../../../data/data.json'
  export default {
    data() {
      return {
        social: json.social
      }
    }
  }
</script>

<style scoped>
  .profile-pic {
    border-radius: 50%;
    border: 0.5em solid white;
  }

  .pp-full-flex {
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/home/ProfilePicture.vue